/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Address,
  AddressResponse,
  Bank,
  BankResponse,
  CargoPublicoData,
  CatalogFile,
  CivilStatus,
  DependenciasData,
  FileCatalogResponse,
  GetCargoPublicoResponse,
  GetCivilStatusResponse,
  GetDependenciasResponse,
  GetMatrimonialRegimesResponse,
  GetPepsTypeDataResponse,
  GetRelationshipResponse,
  MatrimonialRegimesData,
  PepsTypeData,
  RelationshipData,
  StateStructure,
} from "@interfaces/catalogs";
import { baseSecondGuaranteApi } from "./baseSecondGuaranteeApis";
import { ColonyResponse } from "@interfaces/response";
import { CatalosStatusSecondGuaranteeResponse, StepDataSecondGuarantee } from "@interfaces/SecondGuarantee";

const secondGuaranteeCatalogsApi = baseSecondGuaranteApi.injectEndpoints({
  endpoints: (build) => ({
    getStatesGuarantee: build.query<Array<StateStructure>, void>({
      query: () => "catalogos/state",
      transformResponse: (response: { data: any }) => {
        const result = response.data.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
        return result;
      },
    }),
    getAddressTypeSecondGuarantee: build.query<Address[], void>({
      query: () => "catalogos/address_type",
      transformResponse: (response: AddressResponse) => {
        return response.data.data;
      },
    }),
    getCivilStatusSecondGuarantee: build.query<CivilStatus[], void>({
      query: () => `catalogos/civil_status`,
      transformResponse: (response: GetCivilStatusResponse) => {
        return response.data.data;
      },
    }),
    getMatrimonialRegimesSecondGuarantee: build.query<MatrimonialRegimesData[], void>({
      query: () => "catalogos/matrimonial_regimes",
      transformResponse: (response: GetMatrimonialRegimesResponse) => {
        return response.data.data;
      },
    }),
    getDependeciasSecondGuarantee: build.query<DependenciasData[], void>({
      query: () => "catalogos/dependencies",
      transformResponse: (response: GetDependenciasResponse) => {
        return response.data.data;
      },
    }),
    getCargoPublicoSecondGuarantee: build.query<CargoPublicoData[], void>({
      query: () => "catalogos/public_office",
      transformResponse: (response: GetCargoPublicoResponse) => {
        return response.data.data;
      },
    }),
    getPepsTypeSecondGuarantee: build.query<PepsTypeData[], void>({
      query: () => "catalogos/pep_type",
      transformResponse: (response: GetPepsTypeDataResponse) => {
        return response.data.data;
      },
    }),
    getRelationshipSecondGuarantee: build.query<RelationshipData[], void>({
      query: () => "catalogos/relationship",
      transformResponse: (response: GetRelationshipResponse) => {
        return response.data.data;
      },
    }),
    getColonyByIdSecondGuarantee: build.query<ColonyResponse, { colonyId: number }>({
      query: ({ colonyId }) => `/catalogos/colonia/${colonyId}`,
      transformResponse: (response: { data: ColonyResponse }) => {
        return response.data;
      },
    }),

    getStatusSecondGuarantee: build.query<StepDataSecondGuarantee[], { product_id: string; tax_system_id: string }>({
      query: ({ product_id, tax_system_id }) =>
        `/catalogos/status_config?product_id=${product_id}&tax_system_id=${tax_system_id}`,
      transformResponse: (response: CatalosStatusSecondGuaranteeResponse) => {
        return response.data.data;
      },
    }),
    getBanksByCodeSecondGuarantee: build.query<Bank | undefined, string>({
      query: (codeBank) => ({
        url: "catalogos/banks",
        params: {
          q: `code:${codeBank}`,
        },
      }),
      transformResponse: (response: BankResponse) => {
        return response.data.data.length > 0 ? response.data.data[0] : undefined;
      },
    }),
    getFilesCatalogSecondGuarantee: build.query<Array<CatalogFile>, void>({
      query: () => ({
        url: "catalogos/file_category",
        params: {
          size: 1000,
        },
      }),
      transformResponse: (response: FileCatalogResponse) => {
        return response.data.data;
      },
    }),
  }),
});

export const {
  useLazyGetStatesGuaranteeQuery,
  useLazyGetAddressTypeSecondGuaranteeQuery,
  useLazyGetCivilStatusSecondGuaranteeQuery,
  useLazyGetMatrimonialRegimesSecondGuaranteeQuery,
  useLazyGetDependeciasSecondGuaranteeQuery,
  useLazyGetCargoPublicoSecondGuaranteeQuery,
  useLazyGetPepsTypeSecondGuaranteeQuery,
  useLazyGetRelationshipSecondGuaranteeQuery,
  useLazyGetColonyByIdSecondGuaranteeQuery,
  useLazyGetStatusSecondGuaranteeQuery,
  useLazyGetBanksByCodeSecondGuaranteeQuery,
  useGetFilesCatalogSecondGuaranteeQuery,
} = secondGuaranteeCatalogsApi;
